import { render, staticRenderFns } from "./ShowCoursesInCourseGroupsTable.vue?vue&type=template&id=1f80f40e"
import script from "./ShowCoursesInCourseGroupsTable.vue?vue&type=script&lang=js"
export * from "./ShowCoursesInCourseGroupsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports